import classNames from 'classnames';
import css from './BackButton.module.css';
import { FiArrowLeft } from 'react-icons/fi';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useIntl } from 'react-intl';

const BackButton = ({ className = '', onClick }) => {
  const history = useHistory();
  const intl = useIntl();
  return (
    <button
      type="button"
      onClick={e => {
        e.stopPropagation();
        if (onClick) {
          onClick(e);
        } else {
          history.goBack();
        }
      }}
      className={classNames(css.backBtn, className)}
    >
      <FiArrowLeft />
      {/* <span className={css.backTxt}>{intl.formatMessage({ id: 'BackButton.spanBackText' })}</span> */}
    </button>
  );
};

export default BackButton;
